/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Currency from 'react-currency-formatter';
import ReactTooltip from 'react-tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Barcode from 'react-barcode';
import moment from 'moment';
import TagManager from 'react-gtm-module';

import firebase from '~/services/firebase';
import api from '~/services/api';

import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  Content,
  CustomerInfoContainer,
  Info,
  InfoTitle,
  InfoText,
  Hr,
  DetailsContainer,
  SectionTitle,
  Link,
  InvoiceNumber,
  DetailsContent,
  StatusContainer,
  StatusIcon,
  BankSlipContainer,
  TypeableLineContainer,
  TypeableLineText,
  ToolTipText,
  TypeableLineIcon,
  ToolTipButton,
  BarcodeContainer,
  BarcodeContent,
  BarcodeResponsive,
  RemoveSpace,
  DuplicateContainer,
  DuplicateButton,
  DuplicateIcon,
  DuplicateLoading,
  StatusText,
  DuplicateText,
} from './styles';

class Boletos extends Component {
  constructor() {
    super();
    this.state = {
      token: null,
      payment: [],
      installment: {},
      customer: {},
      invoice: {},
      loading: false,
      loadingDownload: false,
      loadingEmail: false,
      status: null,
    };
  }

  componentDidMount() {
    const { payment, installment } = this.props;
    this.organizeData(payment, installment);
    this.handleStatus(installment);
  }

  organizeData = async (payment, installment) => {
    this.setState({ loading: true });
    const { customer } = payment;
    const invoice = payment;
    return await this.setState({
      token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
      invoice,
      customer,
      installment,
    });
  };

  convertLine = (dados) => {
    const line = `${dados}`;
    const bank = line.substring(0, 3);
    const coin = line.substring(3, 4);
    const camp = line.substring(4, 9);
    const camp1 = line.substring(9, 10);
    const camp2 = line.substring(10, 20);
    const camp3 = line.substring(20, 21);
    const camp4 = line.substring(21, 31);
    const camp5 = line.substring(31, 32);
    const camp6 = line.substring(32, 47);
    const result = bank + coin + camp6 + camp + camp2 + camp4;
    return result;
  };

  handleStatus = (installment) => {
    const currentDate = new Date();
    const dueDate = new Date(installment.dueDate);
    dueDate.setDate(dueDate.getDate() + 1);
    if (installment.paymentStatus === 'OP') {
      if (currentDate > dueDate) this.setState({ status: 'Vencido' });
      if (currentDate <= dueDate) this.setState({ status: 'A vencer' });
    } else {
      this.setState({ status: 'Pago' });
    }
  };

  requestDownloadPDF = () => {
    this.setState({ loadingDownload: true });
    const { customer, invoice, token } = this.state;
    firebase.analytics().logEvent('download_nota', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        download_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        download_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      responseType: 'blob',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'DANFE',
      deliveryMethod: 'DOWNLOAD',
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.state.invoice.invoiceId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.setState({ loadingDownload: false });
      })
      .catch((err) => {
        this.setState({ loadingDownload: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  requestEmailPDF = () => {
    firebase.analytics().logEvent('email_nota', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    this.setState({ loadingEmail: true });
    const { customer, invoice, token } = this.state;
    const email = localStorage.getItem('@UltragazEmpresarial:loginEmail');
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'DANFE',
      deliveryMethod: 'EMAIL',
      email,
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((res) => {
        this.setState({ loadingEmail: false });
        toast.success(`Nota fiscal (PDF) enviada para o e-mail ${email}`);
      })
      .catch((err) => {
        this.setState({ loadingEmail: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  requestDownloadXML = () => {
    firebase.analytics().logEvent('download_nota', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        download_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        download_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    this.setState({ loadingXmlDownload: true });
    const { customer, invoice, token } = this.state;
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'XML',
      deliveryMethod: 'DOWNLOAD',
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.state.invoice.invoiceId}.xml`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.setState({ loadingXmlDownload: false });
      })
      .catch((err) => {
        this.setState({ loadingXmlDownload: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  requestEmailXML = () => {
    firebase.analytics().logEvent('email_nota', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        email_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        email_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    this.setState({ loadingXmlEmail: true });
    const { customer, invoice, token } = this.state;
    const email = localStorage.getItem('@UltragazEmpresarial:loginEmail');
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'XML',
      deliveryMethod: 'EMAIL',
      email,
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((res) => {
        this.setState({ loadingXmlEmail: false });
        toast.success(`Nota fiscal (XML) enviada para o e-mail ${email}`);
      })
      .catch((err) => {
        this.setState({ loadingXmlEmail: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  handleCopyToClickBoard = (copyId) => {
    this.setState({
      copyId,
    });
  };

  render() {
    const { close, back } = this.props;
    const {
      installment,
      customer,
      invoice,
      copyId,
      loading,
      loadingDownload,
      loadingEmail,
      loadingXmlDownload,
      loadingXmlEmail,
    } = this.state;

    return (
      <Container>
        <Header>
          <Left>
            {back ? (
              <BackButton title="Fechar" className="mdi mdi-arrow-left" />
            ) : null}
            <Title>Detalhes da cobrança</Title>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <Content>
          <CustomerInfoContainer>
            <Info>
              <InfoTitle>Cliente:</InfoTitle>
              <InfoText>{customer.name}</InfoText>
            </Info>
            <Info className="mt-2">
              <InfoTitle>Endereço:</InfoTitle>
              <InfoText>
                {customer.address}
                ,{customer.addressNumber}
                {' '}
                -{customer.county}
                {' '}
                {customer.city} -{customer.stateCode}
              </InfoText>
            </Info>
          </CustomerInfoContainer>
          <Hr />
          <DetailsContainer>
            <SectionTitle>Detalhes</SectionTitle>
            <DetailsContent>
              <Info>
                <InfoTitle>Emissão:</InfoTitle>
                <InfoText>
                  {moment(invoice.emissionDate).format('DD/MM/YYYY')}
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Valor:</InfoTitle>
                <InfoText>
                  <Currency
                    quantity={invoice.totalAmount}
                    currency="BRL"
                    locale="pt"
                  />
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Número da Nota:</InfoTitle>
                <InfoText>
                  <Link
                    to={`/notas?invoice-number=${this.props.payment.invoiceNumber}`}
                  >
                    <InvoiceNumber>{invoice.invoiceNumber}</InvoiceNumber>
                  </Link>
                </InfoText>
              </Info>
            </DetailsContent>
            {invoice.accessKey && (
              <Info style={{ marginTop: '10px' }}>
                <InfoTitle>Chave de acesso:</InfoTitle>
                <TypeableLineContainer>
                  <InfoText className="codeNotas">{invoice.accessKey}</InfoText>
                  <CopyToClipboard text={invoice.accessKey}>
                    <ToolTipButton
                      onClick={() =>
                        this.handleCopyToClickBoard(invoice.accessKey)
                      }
                      data-tip
                      data-for="copy"
                    >
                      <TypeableLineIcon className="mdi mdi-content-copy" />
                    </ToolTipButton>
                  </CopyToClipboard>
                  {copyId === invoice.accessKey ? (
                    <ReactTooltip
                      id="copy"
                      place="right"
                      effect="solid"
                      type="info"
                    >
                      <ToolTipText>Copiado</ToolTipText>
                    </ReactTooltip>
                  ) : (
                    <ReactTooltip
                      id="copy"
                      place="right"
                      type="info"
                      effect="solid"
                    >
                      <ToolTipText>Clique para copiar</ToolTipText>
                    </ReactTooltip>
                  )}
                </TypeableLineContainer>
              </Info>
            )}
            {installment.existsGeneratedInvoice ? (
              <>
                <BankSlipContainer>
                  <Hr />
                  <DuplicateContainer>
                    <DuplicateText>2ª via da nota</DuplicateText>
                  </DuplicateContainer>
                  {(invoice.source === 'COLETORES' ||
                    invoice.source === 'NFF') && (
                    <>
                      {invoice.accessKey && (
                        <DuplicateContainer>
                          <DuplicateText>PDF</DuplicateText>
                          <DuplicateButton
                            onClick={() => this.requestDownloadPDF()}
                          >
                            {loadingDownload ? (
                              <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                            ) : (
                              <>
                                <DuplicateIcon
                                  className="mdi mdi-cloud-download-outline"
                                  data-tip
                                  data-for="notapdf"
                                  aria-label="Download PDF"
                                />
                                <ReactTooltip
                                  id="notapdf"
                                  place="top"
                                  effect="float"
                                  type="info"
                                >
                                  Download PDF
                                </ReactTooltip>
                              </>
                            )}
                          </DuplicateButton>

                          <DuplicateButton
                            onClick={() => this.requestEmailPDF()}
                          >
                            {loadingEmail ? (
                              <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                            ) : (
                              <>
                                <DuplicateIcon
                                  className="mdi mdi-email-outline"
                                  data-tip
                                  data-for="notaemail"
                                  aria-label="Enviar nota PDF por email"
                                />
                                <ReactTooltip
                                  id="notaemail"
                                  place="top"
                                  effect="float"
                                  type="info"
                                >
                                  Enviar nota PDF por email
                                </ReactTooltip>
                              </>
                            )}
                          </DuplicateButton>
                        </DuplicateContainer>
                      )}
                    </>
                  )}
                  <DuplicateContainer>
                    <DuplicateText>XML</DuplicateText>
                    <DuplicateButton onClick={() => this.requestDownloadXML()}>
                      {loadingXmlDownload ? (
                        <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                      ) : (
                        <>
                          <DuplicateIcon
                            className="mdi mdi-xml"
                            data-tip
                            data-for="notaxml"
                            aria-label="Donwload do XML"
                          />
                          <ReactTooltip
                            id="notaxml"
                            place="top"
                            effect="float"
                            type="info"
                          >
                            Donwload do XML
                          </ReactTooltip>
                        </>
                      )}
                    </DuplicateButton>
                    <DuplicateButton onClick={() => this.requestEmailXML()}>
                      {loadingXmlEmail ? (
                        <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                      ) : (
                        <>
                          <DuplicateIcon
                            className="mdi mdi-email-outline"
                            data-tip
                            data-for="xmlemail"
                            aria-label="Enviar XML por email"
                          />
                          <ReactTooltip
                            id="xmlemail"
                            place="top"
                            effect="float"
                            type="info"
                          >
                            Enviar XML por email
                          </ReactTooltip>
                        </>
                      )}
                    </DuplicateButton>
                  </DuplicateContainer>
                </BankSlipContainer>
              </>
            ) : (
              <RemoveSpace />
            )}
          </DetailsContainer>
        </Content>
      </Container>
    );
  }
}

export default connect()(Boletos);
